export default function getCoinIconName(name: string) {
  return name?.toLowerCase() || 'coin';
}
